import { SiderbarLeftLayoutInterface } from 'ict24h-themes-react/lib/esm/layouts/SidebarLeftLayout'
import { sendParentNavigation } from './ultils'

const dockConfig: SiderbarLeftLayoutInterface['dock'] = {
  items: [
    [
      {
        icon: (
          <img
            src="https://img.icons8.com/?size=32&id=103798&format=png"
            width={32}
            alt="Portal"
          />
        ),
        title: 'Portal',
        // link: "https://i24h-m365-portal-demo.pages-dev.i24h.app/home",
        onClick: () => sendParentNavigation('/home'),
      },
      {
        icon: (
          <img
            src="https://img.icons8.com/?size=64&id=qDNClnB7Z4Ky&format=png"
            width={32}
            alt="Nhân sự"
          />
        ),
        title: 'Nhân sự',
        link: '/hrm/view-employee/cau-hinh-thong-tin/nhan-vien/my-page',
      },
      {
        icon: (
          <img
            src="https://img.icons8.com/external-flaticons-lineal-color-flat-icons/2x/external-kpi-media-agency-flaticons-lineal-color-flat-icons.png"
            width={32}
            alt="KPI"
          />
        ),
        title: 'KPI',
        link: '/hrm/view-employee/danh-gia-kpi/dashboard-kpi',
      },
      {
        icon: (
          <img
            src="https://img.icons8.com/fluency/344/leave.png"
            width={40}
            alt="Nghỉ phép"
          />
        ),
        title: 'Nghỉ phép',
        link: '/hrm/view-employee/nghi-phep-nam/bao-cao-cua-toi',
      },

      {
        icon: (
          <img
            src="https://img.icons8.com/external-itim2101-lineal-color-itim2101/344/external-laptop-computer-technology-itim2101-lineal-color-itim2101-1.png"
            width={32}
            alt="Tài sản"
          />
        ),
        title: 'Tài sản',
        link: '/hrm/quan-ly-tai-san/tai-san',
      },
      {
        icon: (
          <img
            src="https://img.icons8.com/dusk/344/payroll.png"
            width={32}
            alt="Tính lương"
          />
        ),
        title: 'Tính lương',
        link: '/hrm/bang-luong/bao-cao',
      },
      {
        icon: (
          <img
            src="https://img.icons8.com/external-filled-outline-berkahicon/344/external-finger-back-to-work-filled-outline-berkahicon.png"
            width={32}
            alt="Chấm công"
          />
        ),
        title: 'Chấm công',
        link: '/hrm/view-employee/cham-cong/cham-cong-cua-toi',
      },
      {
        icon: (
          <img
            src="https://img.icons8.com/external-icongeek26-linear-colour-icongeek26/344/external-interview-office-icongeek26-linear-colour-icongeek26.png"
            width={32}
            alt="Phỏng vấn"
          />
        ),
        title: 'Phỏng vấn',
        link: '/hrm/view-hr/quan-ly-tuyen-dung/bao-cao',
      },

      // {
      //   icon: <FileText />,
      //   title: "workflow",
      //   link: "/embed-iframe/workflow",
      // },

      // {
      //   icon: <FileText />,
      //   title: "Files",
      //   link: "/sp-files",
      // },
    ],
  ],
}

export default dockConfig
